import { createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-screen-modal" }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "modalWrapper"
}
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = { class: "modal-header ml-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" default header ")
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" default body ")
const _hoisted_9 = { class: "modal-footer" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("i", {
                class: "fal fa-times-circle close-icon",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
              }),
              _createVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _hoisted_6
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "body", {}, () => [
                  _hoisted_8
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "footer")
              ])
            ])
          ], 512)
        ])
      ]),
      _: 3
    })
  ]))
}